import React from "react";

const Bin = ({ size, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={size === "sm" ? "btn btn-sm btn-danger" : "btn btn-danger"}
    >
      <i className="fas fa-trash"></i>
    </button>
  );
};

export default Bin;
